import { Change, Polyline } from '@ritabygglov/core';
import { createUpdateChange } from '../services/Actions';
import { Command } from './Command';

export class UpdatePolylineCommand implements Command {
  constructor(
    private polyline: Polyline,
    private updates: Partial<Polyline>,
    private userId: string,
    public isEphemeral: boolean = false
  ) {}

  execute(): Change[] {
    const polyline = { ...this.polyline, ...this.updates };
    const updateChange = createUpdateChange(
      polyline,
      this.isEphemeral,
      this.userId
    );

    return [updateChange];
  }

  undo(): Change[] {
    const polyline = { ...this.polyline };
    const updateChange = createUpdateChange(
      polyline,
      this.isEphemeral,
      this.userId
    );

    return [updateChange];
  }
}
